import React, { Fragment } from 'react';
import dynamic from 'next/dynamic';

import { CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';
import BreadCrumbs from '../../BreadCrumbs';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';
import CompanyClusterHeaderTitle from '../companyClusterHeader/CompanyClusterHeaderTitle';

const PendingChanges = dynamic(() => import('../companyClusterHeader/PendingChangesHeader'));

const CompanySalaryClusterHeader = ({ subPageName, ...data }) => {
  const { breadCrumbs, claimedCompany, pendingChanges } = data;
  const { companyName, companyNameCPS } = data.companyInfo;

  return (
    <Fragment>
      <div className="company-search">
        {claimedCompany && pendingChanges && <PendingChanges />}
        <div className="container">
          <div className="d-flex align-items-center justify-content-center justify-content-md-between">
            {breadCrumbs && breadCrumbs.length > 0 && (
              <BreadCrumbs breadCrumbs={breadCrumbs.slice(0, breadCrumbs.length - 1)} />
            )}
            <SearchBar
              subPageName={subPageName}
              clusterCategory={CLUSTER_HEADER_CATEGORY.COMPANY}
            />
          </div>
          <CompanyClusterHeaderTitle
            subPageName={subPageName}
            title={companyNameCPS || companyName}
            data={data}
          />
        </div>
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
    </Fragment>
  );
};

export default CompanySalaryClusterHeader;
